export default {"src":"/_next/static/media/omnichannel-3.17ad6b24.svg","height":121,"width":118,"blurWidth":0,"blurHeight":0};